const $masthead = $('header.masthead');

// scroll to next section
$('.section__scroll-down-btn').on('click', function () {
    let $this = $(this),
        $target = $(this).closest('.section').nextAll('.section').first(),
        scrollOffset = $masthead.outerHeight();

    // if target exists
    if ($target.length > 0) {

        // if target has top margin, add half of it to scroll offset
        let targetMargin = parseInt($target.css('marginTop'));

        if (targetMargin > 0) {
            scrollOffset = scrollOffset + (targetMargin / 2);
        }

        // calculate sroll duration based on distance
        let scrollTo = $target.offset().top - scrollOffset,
            scrollDuration = (scrollTo - $(document).scrollTop()) * 1.5;

        // set max duration
        if (scrollDuration > 1000) scrollDuration = 1000;

        $('html, body').stop().animate({
            scrollTop: scrollTo,
        }, scrollDuration, 'swing').promise().done(function () {
            $this.blur();
        });
    }
});
